import { Control, Controller } from 'react-hook-form';

import AutocompleteMultiInput from '@/components/inputs/AutocompleteMultiInput';
import type { Option } from '@/components/inputs/AutocompleteInput';

export interface FormAutocompleteMultiInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  options: Option[];
  inputValue?: string;
  onInputChange?: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  loading?: boolean;
  getOptionId?: (option: Option) => string;
  /** Etiquetas por id para los seleccionados que no están en options. */
  labelsById?: Record<string, string>;
  keepOptionsOrder?: boolean;
  compactSelection?: boolean;
  keepInputOnSelect?: boolean;
}

const FormAutocompleteMultiInput = ({
  name,
  placeholder,
  control,
  options,
  inputValue,
  onInputChange,
  required = false,
  disabled = false,
  loading = false,
  getOptionId,
  labelsById,
  keepOptionsOrder,
  compactSelection,
  keepInputOnSelect,
}: FormAutocompleteMultiInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <AutocompleteMultiInput
          name={name}
          placeholder={placeholder}
          value={field.value ?? []}
          onChange={field.onChange}
          options={options ?? []}
          errorInfo={error?.message}
          error={!!error}
          required={required}
          disabled={disabled}
          loading={loading}
          getOptionId={getOptionId}
          keepOptionsOrder={keepOptionsOrder}
          compactSelection={compactSelection}
          keepInputOnSelect={keepInputOnSelect}
          {...(labelsById !== undefined && { labelsById })}
          {...(inputValue !== undefined && { inputValue })}
          {...(onInputChange !== undefined && { onInputChange })}
        />
      )}
    />
  );
};

export default FormAutocompleteMultiInput;
